import { useCallback } from 'react';

import { useBridgeApi } from '@/api/BridgeApi';

type OpenChatPanelRequest = {
	panel_type: string;
	item_id: string;
	artifact_type?: string;
	// A request or proposal card is keyed by the request or the proposal, so the
	// bridge needs this to resolve the strategy the card names.
	strategy_id?: string;
};

// Opens a panel and names the thread it was asked for, so a request that
// arrives after the customer has moved on is dropped rather than dropping one
// thread's panel into another thread's conversation. Actions round-trip over the
// websocket with nothing applied locally first, so that gap is real.
//
// The thread is read when the panel is asked for, not when the handler is built:
// the chat view and the strategy dock stay mounted across thread switches, so a
// thread read at render time would go stale and start dropping every open.
export const useOpenChatPanel = (): ((
	request: OpenChatPanelRequest,
) => void) => {
	const bridgeApi = useBridgeApi();
	return useCallback(
		(request: OpenChatPanelRequest) => {
			const chatId = bridgeApi.user_state?.current_chat_id;
			bridgeApi.sendAction({
				type: 'do_open_chat_panel',
				...(chatId && { chat_id: chatId }),
				...request,
			});
		},
		[bridgeApi],
	);
};
